import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { PendingRequestsService } from './pending-request.service';


@Injectable()
export class PendingRequestsInterceptor implements HttpInterceptor {
  constructor(private pendingRequests: PendingRequestsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.pendingRequests.addRequest();
    return next.handle(req).pipe(
      finalize(() => this.pendingRequests.removeRequest())
    );
  }
}